import React from 'react';
import { useQuery } from '@apollo/client/react';
import { API_TOKENS_QUERY } from '../graphql/queries';
import DataTable from '../components/DataTable';
import EmptyState from '../components/EmptyState';

export default function ApiTokensPage() {
  const { data, loading } = useQuery(API_TOKENS_QUERY);

  const columns = [
    { key: 'name', title: 'Name' },
    {
      key: 'lastUsedAt',
      title: 'Last Used',
      render: (v) => (v ? new Date(v).toLocaleDateString() : 'Never')
    },
    { key: 'revoked', title: 'Status', render: (v) => (v ? 'Revoked' : 'Active') },
    { key: 'createdAt', title: 'Created', render: (v) => new Date(v).toLocaleDateString() }
  ];

  if (loading) return <div className="page-content">Loading...</div>;
  if (!data?.apiTokens?.length) {
    return (
      <div className="page-content">
        <EmptyState
          icon="key"
          title="No API Tokens"
          message="No API tokens have been created yet."
        />
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>API Tokens</h1>
      </div>
      <DataTable
        columns={columns}
        data={data.apiTokens}
        loading={loading}
        rowKey="id"
        emptyMessage="No API tokens found"
      />
    </div>
  );
}
